import { Button, Modal, Form, Row, Col, Input, message } from "antd";
import { useEffect, useState } from "react";
import getBase64 from "../../../../utils/getBase64";
import patchDataClaim from "../../../../services/patchDataClaim";
import { useQueryClient } from "@tanstack/react-query";

export default function UpdateFirm({ isVisible, setVisible, selected }: any) {
  const [isLoading, setLoading] = useState(false);
  const queryClient = useQueryClient();

  const [isSelected, setIsSelected] = useState(false);
  const [selectedFile, setSelectedFile]: any = useState();

  const [form] = Form.useForm();

  const changeHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    setIsSelected(true);
  };

  const onSubmit = async () => {
    setLoading(true);
    const { name, code, address1, address2, address3, address4, website } =
      await form.getFieldsValue();
    let base64 = null;
    if (selectedFile) {
      base64 = await getBase64(selectedFile);
    }
    const data = {
      name,
      code,
      logo: base64,
      address1,
      address2,
      address3,
      address4,
      website,
    };
    const uri = `firms/${selected?._id}`;
    const response = await patchDataClaim(data, uri);
    if (response.success) {
      message.success("Updated Successfully");
      queryClient.invalidateQueries({ queryKey: ["firms"] });
      form.resetFields();
      setVisible(false);
    } else {
      message.error(response.message);
    }
    setLoading(false);
  };

  useEffect(() => {
    form.resetFields();
  }, [selected]);

  return (
    <Modal
      open={isVisible}
      title="Update Company"
      onCancel={() => setVisible(!isVisible)}
      footer={[
        <Button danger key="back" onClick={() => setVisible(!isVisible)}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="updateFirm"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="updateFirm"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="name"
              label="Company Name"
              initialValue={selected?.name}
              rules={[
                {
                  required: true,
                  message: "Please enter company name",
                },
              ]}
            >
              <Input placeholder="Company name" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="website"
              label="Company Website"
              initialValue={selected?.website}
              rules={[
                {
                  required: true,
                  message: "Please enter website",
                },
              ]}
            >
              <Input placeholder="Company Website" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address1"
              label="Address 1"
              initialValue={selected?.address1}
              rules={[
                {
                  required: true,
                  message: "Please enter address 1",
                },
              ]}
            >
              <Input placeholder="Address 1" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address2"
              label="Address 2"
              initialValue={selected?.address2}
              rules={[
                {
                  required: true,
                  message: "Please enter address 2",
                },
              ]}
            >
              <Input placeholder="Address 2" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address3"
              label="Address 3"
              initialValue={selected?.address3}
              rules={[
                {
                  required: true,
                  message: "Please enter address 3",
                },
              ]}
            >
              <Input placeholder="Address 3" />
            </Form.Item>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="address4"
              label="Address 4"
              initialValue={selected?.address4}
              rules={[
                {
                  required: true,
                  message: "Please enter address 4",
                },
              ]}
            >
              <Input placeholder="Address 4" />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 24 }}>
            <Form.Item
              name="file"
              label="Company Logo"
              rules={[
                {
                  required: false,
                  message: "Please select file",
                },
              ]}
            >
              <Input
                type="file"
                accept="image/png, image/gif, image/jpeg"
                placeholder="Document"
                onChange={changeHandler}
              />
            </Form.Item>
            {isSelected && <div className="text-sm text-green-500">File selected</div>}
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
